// removed by extract-text-webpack-plugin
module.exports = {"Tabs":"src-containers-Auth-__AuthPage-module___Tabs"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Auth/AuthPage.module.css
// module id = 1192
// module chunks = 1